import { render, staticRenderFns } from "./IconVisa.vue?vue&type=template&id=1bc09637&"
import script from "./IconVisa.vue?vue&type=script&lang=ts&"
export * from "./IconVisa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports